<!--
 * @Description: 
 * @Date: 2020-09-25 10:48:46
 * @LastEditors: jml
-->
<template>
  <div class="game-list" @touchmove="preLoad($event)">
    <div class="header">
      <span class="title">热门活动送好礼</span>
      <div class="btn" @click="toRewardLogPage">
        <img src="./img/common/reward-icon.png" class="reward-icon" alt />
        <span>中奖记录</span>
      </div>
    </div>
    <list v-bind="$data" :defaultMid="true">
      <div class="list">
        <div
          class="item"
          v-for="(item,index) in listData "
          :key="index"
          :class="['','game-puzzle','game-lucky','game-share'][item.activityType]"
          @click="toGamePage(item.activityType,item.id)"
        >
          <div class="top">
            <div class="thumb">
              <img :src="item.activityIcon" alt />
            </div>
            <div class="info">
              <div class="name text-overflow-1">{{item.activityTitle}}</div>
              <div class="desc text-overflow-1">{{item.activitySubtitle}}</div>
            </div>
          </div>
          <div class="bottom">
            <div class="time">{{item.time}}</div>
          </div>
        </div>
      </div>
    </list>
  </div>
</template>

<script>
import { loadMore } from '@/mixins/loadMore';
import dateFormat from '@/utils/dateFormat';
import { puzzle } from '@/api/game';
import list from '@/components/list/defaultList.vue';
export default {
  name: 'gameList',
  data() {
    return {
      listAjax: puzzle.activityList
    };
  },
  mixins: [loadMore],
  components: { list },
  methods: {
    toRewardLogPage() {
      this.$router.push({
        name: 'gameRewardLog'
      });
    },
    toGamePage(gameType, gameId) {
      const nameObj = {
        1: 'puzzleGame'
      };
      this.$router.push({
        name: nameObj[gameType],
        params: { id: gameId }
      });
    },
    async listFunc() {
      try {
        let {
          data: { data }
        } = await this.listAjax(this.pageObj);
        data.list = (data.list || []).reduce((pre, cur) => {
          pre.push({
            ...cur,
            time: `活动时间：${dateFormat(
              cur.startDt,
              'YYYY-MM-DD HH:mm'
            )}--${dateFormat(cur.endDt, 'YYYY-MM-DD HH:mm')}`
          });
          return pre;
        }, []);
        return Promise.resolve(data);
      } catch (e) {
        return Promise.reject();
      }
    }
  },
  created() {
    this.getList({ init: true });
  }
};
</script>

<style lang="less" scoped>
.game-list {
  .header {
    padding: 0.43rem;
    padding-bottom: 0.64rem;
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 0.43rem;
      font-weight: bold;
      color: #323235;
    }
    .btn {
      display: flex;
      align-items: center;
      .reward-icon {
        width: 0.43rem;
        height: 0.43rem;
        margin-right: 0.15rem;
      }
      span {
        font-size: 0.43rem;
        color: #959599;
        line-height: 0.43rem;
      }
    }
  }
  .list {
    .item {
      width: 9.15rem;
      height: 2.85rem;
      background-image: url('./img/common/puzzle.png');
      background-size: 100% 100%;
      border-radius: 0.21rem;
      margin: 0 auto;
      margin-bottom: 0.33rem;
      padding: 0.32rem;
      &.game-puzzle {
        background-image: url('./img/common/puzzle.png');
      }
      &.game-lucky {
        background-image: url('./img/common/lucky.png');
      }
      &.game-share {
        background-image: url('./img/common/share.png');
      }
      .top {
        display: flex;
        align-items: center;
        .thumb {
          width: 1.39rem;
          height: 1.39rem;
          border-radius: 0.11rem;
          overflow: hidden;
          margin-right: 0.32rem;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          padding-bottom: 0.11rem;
          width: 80%;
          .name {
            font-size: 0.48rem;
            font-weight: 500;
            color: #ffffff;
            margin-bottom: 0.32rem;
            line-height: 2;
          }
          .desc {
            font-size: 0.37rem;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.8);
            line-height: 2;
          }
        }
      }
      .bottom {
        margin-top: 0.15rem;
        .time {
          font-size: 0.29rem;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1;
        }
      }
    }
  }
}
</style>